module.exports = vendors_en_86bc4013f0ebbbdd3b42;